<div class="flex flex-col">
  <div class="flex flex-row items-center">
    <label class="input-main-label mt-0">Two-Factor Authentication</label>
    <mat-slide-toggle
      class="main-toggle mr-3"
      (change)="onChange($event.checked)"
      [checked]="client()?.requireTotp"
    />
    <img
      class="w-5 h-5"
      alt="help"
      matTooltip="Requires all users of this client to set up 2FA. Users will have a 7-day grace period from when this is turned on to complete setup."
      matTooltipPosition="above"
      src="assets/icons/help.svg"
    />
  </div>
</div>
